import { Directive } from '@angular/core';
import { ImmomioIconName } from '../../models';

@Directive()
export class TileBaseComponent {
  public immomioIconName = ImmomioIconName;
}
